module.exports = __webpack_public_path__ + "avenida-paulista.f9da3baeed2c5f44a31858379fc33b3f.jpg";